import clsx from 'clsx'

/** An en dash: not a minus sign. Grids leave an empty cell blank instead. */
export const EMPTY_VALUE_MARK = '–'

/** "No value" outside a grid: a muted en dash, read as "No value" by assistive tech. */
export default function EmptyValue({ className }: { className?: string }) {
  return (
    <span className={clsx('text-muted', className)}>
      <span aria-hidden="true">{EMPTY_VALUE_MARK}</span>
      <span className="sr-only">No value</span>
    </span>
  )
}
